module.exports = __webpack_public_path__ + "static/media/pick11-cricketplayer@2x.b26aec54.png";